import processReport from '@/assets/js/report/nvit_packing'
export default {
  methods: {
    async genereateNvitPackReportContent (getObj) {
      if (!getObj) getObj = {}
      let customerLang = (getObj && getObj.customer_language) ? getObj.customer_language : this.$i18n.locale
      let lang = this.$i18n.messages[customerLang].message
      if (getObj) {
        let headers = [
          { text: lang.orders.productNo, value: 'number', width: '12%' },
          { text: lang.customer.name, value: 'producttext', width: '28%' },
          { text: lang.invoice.qty, value: 'qty', width: '7%' },
          { text: 'HS', value: 'hs', width: '10%' },
          { text: lang.product.weight, value: 'netweight_total', width: '13%' },
          { text: lang.common.comments, value: 'comments', width: '30%' }
        ]
        let { products, totalNetWeight, totalGrossWeight } = await this.getNvitOrderPackProducts(getObj.id)
        let translationData = {
          confirm: lang.orders.nvitPackList,
          number: lang.order.orderNumber,
          customer: lang.order.customer,
          contact: lang.order.yourContactPerson,
          contactPhone: lang.order.contactPhone,
          currency: lang.product.currency,
          deliveryAddress: lang.orders.deliveryAddress,
          responsible: lang.deviations.responsible,
          ourreference: lang.orders.ourReference,
          yourreference: lang.orders.yourReference,
          offerdate: lang.orders.offerDate,
          orderdate: lang.whOrder.orderDate,
          deliverydate: lang.order.shippingDate,
          shipment: lang.customer.shipmentReport,
          paymentTerm: lang.order.paymentTerms,
          deliveryTerm: lang.order.deliveryTerm,
          invoiceTo: lang.orders.invoiceTo,
          invoiceAddress: lang.orders.invoiceAddress,
          days: lang.common.days,
          restorder: lang.orders.restOrderFor,
          saleRef: lang.invoiceReport.saleRef,
          phone: lang.customer.phone,
          yourOrderNum: lang.orders.yourOrderNumber,
          customerNum: lang.unimicro.customerNumber,
          labeled: lang.order.labeled,
          netWeightLabel: lang.product.weight,
          grossWeightLabel: lang.product.grossWeight,
          totalNetWeightLabel: lang.product.netweightTotal,
          totalGrossWeightLabel: lang.product.grossweightTotal,
          totalLabel: lang.common.total,
          totalNetWeight: this.$formatter.replaceDotWithComma(totalNetWeight),
          totalGrossWeight: this.$formatter.replaceDotWithComma(totalGrossWeight)
        }
        let getBase64Content = processReport(headers, products, getObj, translationData, getObj.restcreatedfromnumber)
        return getBase64Content
      }
    },
    getNvitOrderPackProducts (id) {
      return new Promise((resolve, reject) => {
        this.$_executeApi('get', `ordermaterials/get_materials_packlist/${id}`)
          .then((response) => {
            if (response.data) {
              const allMaterials = response.data
              var pickedQtyCalculatedList = this.getNvitPickedQtyCalculatedList(allMaterials)
              let getMaterialsForRest = pickedQtyCalculatedList.filter(x => !x.packageid && !x.mainpackageid && (x.orderindex === null || x.orderindex <= 0))
              let totalNetWeight = 0
              let totalGrossWeight = 0
              getMaterialsForRest.map(x => {
                const rawQty = parseFloat(String(x.qty || 0).replace(',', '.')) || 0
                const unitNet = parseFloat(String(x.netweight || 0).replace(',', '.')) || 0
                const unitGross = parseFloat(String(x.grossweight || 0).replace(',', '.')) || 0
                const rowNetTotal = rawQty * unitNet
                const rowGrossTotal = rawQty * unitGross
                totalNetWeight += rowNetTotal
                totalGrossWeight += rowGrossTotal
                x.netweight_total = rowNetTotal ? this.$formatter.replaceDotWithComma(rowNetTotal) : ''
                x.qty = this.$formatter.replaceDotWithComma(x.qty)
                x.updatedon = this.$formatter.formatDate(x.updatedon, 'DD.MM.YYYY', 'DD.MM.YYYY')
                if (x.isfreight) {
                  x.producttext = 'Frakt'
                  x.number = '1000'
                }
                return x
              })
              resolve({ products: getMaterialsForRest, totalNetWeight, totalGrossWeight })
            }
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    getNvitPickedQtyCalculatedList (allMaterials) {
      var materials = allMaterials.filter(x => !x.orderindex)
      var productsSplittedItems = allMaterials.filter(x => x.orderindex && x.pickedqty)
      var splittedItems = this.$_groupBy(productsSplittedItems, 'orderindex')
      Object.entries(splittedItems).forEach(orderIndex => {
        var productIndex = materials.findIndex(x => x.id === +orderIndex[0])
        if (productIndex > -1) {
          var totalqty = orderIndex[1].reduce((val, obj) => obj.pickedqty + val, 0)
          materials[productIndex].pickedqty += totalqty
        }
      })
      var productsToAutoSetPickedQty = materials.filter(x => x.isfreight || x.product_type === 'work')
      productsToAutoSetPickedQty.forEach((product) => {
        var productIndex = materials.findIndex(x => x.id === product.id)
        if (productIndex > -1) materials[productIndex].pickedqty = materials[productIndex].qty
      })
      var topListProducts = materials.filter(x => !x.packageid && !x.mainpackageid)
      return topListProducts
    }
  }
}
